import { render, staticRenderFns } from "./SScrollView.vue?vue&type=template&id=5e29c375&scoped=true&"
import script from "./SScrollView.vue?vue&type=script&lang=js&"
export * from "./SScrollView.vue?vue&type=script&lang=js&"
import style0 from "./SScrollView.vue?vue&type=style&index=0&id=5e29c375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29c375",
  null
  
)

export default component.exports